import React from 'react';
import { FiSmartphone } from 'react-icons/fi';

/**
 * DevicePhoneIcon
 * Ikona smartfónu pre zobrazenie akcií súvisiacich s mobilným zariadením.
 */
const DevicePhoneIcon = ({ className = 'inline-block align-middle', ...props }) => (
  <FiSmartphone className={className} {...props} />
);

export default DevicePhoneIcon;

